import { render, staticRenderFns } from "./b21.vue?vue&type=template&id=2d08e8f3&scoped=true"
import script from "./b21.vue?vue&type=script&lang=js"
export * from "./b21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08e8f3",
  null
  
)

export default component.exports